
import { Truck, Service, TeamMember } from './types';
import { Truck as TruckIcon, Wrench, Shield, Globe, Settings, DollarSign } from 'lucide-react';

export const TRUCKS: Truck[] = [
  {
    id: 't1',
    name: 'Scania R500 V8 Streamline',
    brand: 'Scania',
    category: 'Heavy Duty',
    year: 2021,
    engine: '16L V8',
    horsepower: 500,
    image: 'https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&q=80&w=1000',
    maxSpeed: '90 km/h',
    available: true,
    featured: true,
    location: 'Dar es Salaam',
    features: ['Retarder', 'Opticruise', 'Air Suspension', 'Double Sleeper'],
    description: 'A top-tier heavy duty truck perfect for long haul logistics. Features the legendary V8 engine for superior performance on East African roads.',
    transmission: 'Automatic',
    fuelType: 'Diesel',
    condition: 'Used',
    color: 'White'
  },
  {
    id: 't2',
    name: 'Mercedes-Benz Actros 2645',
    brand: 'Mercedes-Benz',
    category: 'Logistics',
    year: 2022,
    engine: '12.8L Inline-6',
    horsepower: 450,
    image: 'https://images.unsplash.com/photo-1591768793355-74d04bb6608f?auto=format&fit=crop&q=80&w=1000',
    maxSpeed: '120 km/h',
    available: true,
    featured: true,
    location: 'Nairobi',
    features: ['MirrorCam', 'Active Brake Assist 5', 'Predictive Powertrain Control'],
    description: 'The new Actros with MirrorCam technology. Optimized for fuel efficiency and driver comfort.',
    transmission: 'Automatic',
    fuelType: 'Diesel',
    condition: 'Used',
    color: 'Silver'
  },
  {
    id: 't3',
    name: 'Volvo FMX 460 8x4',
    brand: 'Volvo',
    category: 'Construction',
    year: 2023,
    engine: 'D13K',
    horsepower: 460,
    image: 'https://images.unsplash.com/photo-1586015555751-63c6c06a86c6?auto=format&fit=crop&q=80&w=1000',
    maxSpeed: '100 km/h',
    available: true,
    featured: true,
    location: 'Dar es Salaam',
    features: ['I-Shift Crawler', 'Tandem Axle Lift', 'Heavy Duty Bumper'],
    description: 'Built for the toughest construction sites. The FMX is robust, reliable, and ready for heavy loads.',
    transmission: 'Automatic',
    fuelType: 'Diesel',
    condition: 'New',
    color: 'Yellow'
  },
  {
    id: 't4',
    name: 'Sinotruk HOWO 371',
    brand: 'Sinotruk',
    category: 'Construction',
    year: 2020,
    engine: 'WD615.47',
    horsepower: 371,
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&q=80&w=1000',
    maxSpeed: '85 km/h',
    available: true,
    location: 'Kampala',
    features: ['Reinforced Dump Body', 'Off-road Tires', 'Simple Maintenance'],
    description: 'Cost-effective workhorse for mining and construction sites.',
    transmission: 'Manual',
    fuelType: 'Diesel',
    condition: 'Used',
    color: 'Red'
  },
  {
    id: 't5',
    name: 'Isuzu FVR 900',
    brand: 'Isuzu',
    category: 'Medium Duty',
    year: 2022,
    engine: '6HK1-TCS',
    horsepower: 280,
    image: 'https://images.unsplash.com/photo-1616401784845-180886ba9bb8?auto=format&fit=crop&q=80&w=1000',
    maxSpeed: '110 km/h',
    available: false,
    location: 'Dar es Salaam',
    features: ['ABS', 'Turbo Intercooler', 'High Payload Capacity'],
    description: 'Ideal for regional distribution and medium loads. Reliable Isuzu engineering.',
    transmission: 'Manual',
    fuelType: 'Diesel',
    condition: 'Used',
    color: 'White'
  },
  {
    id: 't6',
    name: 'DAF XF 480 Super Space',
    brand: 'DAF',
    category: 'Logistics',
    year: 2021,
    engine: 'PACCAR MX-13',
    horsepower: 483,
    image: 'https://images.unsplash.com/photo-1568285741865-c8c7c94b7913?auto=format&fit=crop&q=80&w=1000',
    maxSpeed: '130 km/h',
    available: true,
    location: 'Mombasa',
    features: ['Super Space Cab', 'Predictive Cruise', 'Lane Departure Warning'],
    description: 'Maximum space and comfort for the driver. Excellent fuel economy for long haul.',
    transmission: 'Automatic',
    fuelType: 'Diesel',
    condition: 'Used',
    color: 'Orange'
  }
];

export const SERVICES: Service[] = [
  {
    id: 's1',
    title: 'Fleet Maintenance',
    description: 'Comprehensive scheduled maintenance for commercial fleets across East Africa.',
    icon: 'wrench'
  },
  {
    id: 's2',
    title: 'Genuine Parts',
    description: 'Authorized distributor for OEM parts with regional delivery within 48 hours.',
    icon: 'settings'
  },
  {
    id: 's3',
    title: 'Warranty Support',
    description: 'Extended warranty packages and certified repair centers in 5 countries.',
    icon: 'shield'
  },
  {
    id: 's4',
    title: 'Export Logistics',
    description: 'Complete paperwork and delivery handling for cross-border vehicle purchases.',
    icon: 'globe'
  }
];

export const EXCHANGE_RATE_TZS = 2550; // 1 USD to TZS approx
